import { FormsFeatureContext, IDataSingleResponse } from '@ngt/forms';
import { useCallback, useContext } from 'react';
import { KeyedMutator } from 'swr';
import { LotProperty, LotPropertyPostRowEdit } from '../../api/dtos';

export const usePostLotPropertyEdit = (_mutate?: KeyedMutator<IDataSingleResponse<LotProperty>>) => {
    const { serviceStackClient } = useContext(FormsFeatureContext);

    const save = useCallback(async (lotId?: number, propertyId?: number, value?: string): Promise<LotProperty | undefined> => {
        if (lotId == null || !Number.isFinite(lotId)) throw new Error('A valid lot ID is required to save a lot property.');
        if (propertyId == null || !Number.isFinite(propertyId)) throw new Error('A valid property ID is required to save a lot property.');
        const response: unknown = await serviceStackClient.post(
            new LotPropertyPostRowEdit({ lotId, propertyId, value }),
        );
        if (response === false) throw new Error('The lot property save was rejected.');
        return (response as IDataSingleResponse<LotProperty> | null | undefined)?.data ?? undefined;
    }, [serviceStackClient]);

    return save;
};

export default usePostLotPropertyEdit;
